
import { defineComponent } from 'vue'

// @components
import NewButton from '@/ui-kit/NewButton/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'
import { PropType } from 'vue'
import CargoStatus from '@/modules/NewDispatcher/components/CargoStatus/index.vue'

export default defineComponent({
    name: 'new_modal',
    components: {
        NewButton,
        Cheap,
        CargoStatus,
    },
    props: {
        title: {
            type: String,
            default: 'Modal title',
        },
        titleTo: {
            type: String,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        isTakes: {
            type: Boolean,
            default: false,
        },
        takesStatus: {
            type: Object as PropType<{ title: string; id: number }>,
            default: null,
        },
        cheapText: {
            type: String,
            default: null,
        },
        cheapClass: {
            type: String,
            default: null,
        },
        confirmButtonText: {
            type: String,
            default: 'Понятно',
        },
        confirmButtonClass: {
            type: String,
            default: '',
        },
        confirmDisabled: {
            type: Boolean,
            default: false,
        },
        withoutFooter: {
            type: Boolean,
            default: false,
        },
        maxWidth: {
            type: String,
            default: '32rem',
        },
        width: {
            type: String,
            default: '32rem',
        },
    },
    emits: ['cancel', 'submit'],
    setup(props, { emit }) {
        const emitCancel = () => {
            emit('cancel')
        }

        const emitSubmit = () => {
            emit('submit')
        }

        return {
            emitCancel,
            emitSubmit,
        }
    },
})
